// extracted by mini-css-extract-plugin
module.exports = {"v1w8bxmu":"v1w8bxmu"};